// extracted by mini-css-extract-plugin
export var aboveInput = "_oc-0";
export var actionButton = "_oc-5";
export var actionButtonContainer = "_oc-1";
export var actionIcon = "_oc-6";
export var aiInfoContainer = "_oc-2";
export var attachmentWrapper = "_oc-7";
export var bold = "_oc-3";
export var checkIcon = "_oc-8";
export var clickingRecipientBar = "_oc-11";
export var commentThreadSwitch = "_oc-a";
export var draftImage = "_oc-b";
export var draftImageContainer = "_oc-c";
export var draftImages = "_oc-e";
export var editButton = "_oc-g";
export var editor = "_oc-f";
export var editorContainer = "_oc-y";
export var editorErrorTooltipWrapper = "_oc-9";
export var headerDivider = "_oc-h";
export var icon = "_oc-i";
export var info = "_oc-j";
export var internal = "_oc-n";
export var internalDivider = "_oc-k";
export var internalMessage = "_oc-l";
export var messageInputCard = "_oc-m";
export var messageInputForm = "_oc-o";
export var messageInputFormInternal = "_oc-p";
export var options = "_oc-q";
export var publicMessageCustomer = "_oc-s";
export var publicMessageMerchant = "_oc-r";
export var removeImageButton = "_oc-d";
export var replyButtons = "_oc-t";
export var showSignatureButton = "_oc-u";
export var spinner = "_oc-v";
export var verticalButtonDivider = "_oc-4";
export var visibilitySelector = "_oc-w";
export var warning = "_oc-x";
export var wrappingText = "_oc-z";
export var writingInternalNoteTopBorder = "_oc-10";